<template>
  <div v-if="state.isLoggedIn()">
    <div class="gmf-context gmf-notif-dropdown-btn" @click="toggle">
      <Avatar v-if="useAvatarIcon" disablePopup :customer="state.profile" :style="{animation: newNotificationCount > 0 ? null : 'none !important'}" />
      <Icon v-else icon="notification-bell" :style="{animation: newNotificationCount > 0 ? null : 'none !important'}" />
      <div class="gmf-notif-dropdown-btn-count" v-text="newNotificationCount" ref="count" v-if="newNotificationCount > 0 && ! isOpen"></div>
    </div>

    <DropdownContent v-if="isOpen" @close="close">
      <div class="gmf-context gmf-notif-dropdown" ref="dropdownEl">
        <div class="gmf-notif-member-container" v-if="config.notificationAvatar">
          <CompactProfileCard :profile="profile" />
          <div class="gmf-notif-menu">
            <a class="gmf-btn gmf-btn-sm gmf-btn-primary" @click="openSocialModal({ displayHeader: true })" href="#">{{ t('community') }}</a>
            <Link v-if="config.myPagesUrl" class="gmf-btn gmf-btn-sm gmf-btn-primary" :href="config.myPagesUrl">{{ t('my_pages') }}</Link>
          </div>
          <div class="gmf-dropdown-divider">
            <span class="gmf-dropdown-centered-text" v-text="t('notifications')" />
            <hr>
          </div>
        </div>
        <NotificationList />
      </div>
    </DropdownContent>
  </div>
</template>

<style>
#gmf-notification-dropdown * {
  user-select: none;
}
#gmf-notification-dropdown {
  position: relative;
  float: left;
}

.gmf-notif-dropdown-btn {
  height: 50px;
  width: 50px;
  background-color: #ffffff00;

  cursor: pointer;
}

.gmf-notif-dropdown-btn .gmf-icon, .gmf-notif-dropdown-btn .gmf-avatar {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  will-change: transform;
  animation: gmf_notif_wiggle 5s ease-in-out infinite;
  background-size: 50%;
  transform-origin: center;

  pointer-events: none;
}

@keyframes gmf_notif_wiggle {
  0% {
    transform: rotate(6deg) scale(1.05);
  }
  3% {
    transform: rotate(-6deg) scale(1.10);
  }
  6% {
    transform: rotate(6deg) scale(1.10);
  }
  9% {
    transform: rotate(-6deg) scale(1.10);
  }
  12% {
    transform: rotate(6deg) scale(1.10);
  }
  15% {
    transform: rotate(-6deg) scale(1.05);
  }
  18%, 100% {
    transform: scale(1);
  }
}

/*
.gmf-notif-dropdown-btn:hover {
  background-color: #ffffff22;
}
*/
.gmf-notif-dropdown-btn-count {
  height: 16px;
  width: 16px;
  color: white !important;
  background: var(--gmf-notification-color);
  border-radius: 100%;
  text-align: center;
  line-height: 16px !important;
  vertical-align: middle;
  font-weight: bold !important;
  position: absolute;
  right: 4px;
  top: 4px;
  font-size: 11px !important;
  text-shadow: 0px 0px 3px black;

  transform-origin: center;
  box-shadow: 0px 1px 1px rgb(0 0 0 / 30%);

  animation: gmf_notif_count_pop 0.25s ease-out;
}

@keyframes gmf_notif_count_pop {
  from {
    transform: scale(1.25);
  }
  to {
    transform: scale(1);
  }
}

.gmf-notif-dropdown {
  background: var(--gmf-col-white);
  width: 420px;
  max-width: 100%;
  border-radius: var(--gmf-rounding);
  padding: var(--gmf-p-3);
  display: flex;
  flex-direction: column;
  box-shadow: 0px 1px 6px rgba(0,0,0,.2);
  max-height: min(75vh, 650px);
  overflow-x: hidden;
  overflow-y: auto;
}

/* width */
.gmf-notif-dropdown::-webkit-scrollbar {
  width: 4px;
  background: transparent;
}

/* Track */
.gmf-notif-dropdown::-webkit-scrollbar-track {
  background: transparent;
}

/* Handle */
.gmf-notif-dropdown::-webkit-scrollbar-thumb {
  background: var(--gmf-col-darkgray);
  border-radius: 4px;
}

.gmf-notif-member-container {
  padding: 0 var(--gmf-p-2);
  margin-top: var(--gmf-p-2);
}


.gmf-notif-menu {
  display: flex;
  gap: var(--gmf-p-3);
  margin: var(--gmf-p-3) 0;
}

.gmf-context .gmf-notif-menu .gmf-btn-sm {
  padding: 8px 14px;
  font-size: 14px;
}

.gmf-dropdown-divider {
  position: relative;
  margin-bottom: var(--gmf-p-4);
}

.gmf-dropdown-divider hr {
  margin-top: var(--gmf-p-5);
  margin-bottom: calc(var(--gmf-subheader-font-size) / 2);
}

.gmf-context .gmf-dropdown-centered-text {
  color: var(--gmf-col-darkgray);
  transform: translate(-50%, -50%);
  padding: 0 var(--gmf-p-3);
  background: white;
  position: absolute;
  text-align: center;
  left: 50%;
  top: 50%;
}

</style>

<script>
import notificationFetcher from './notificationFetcher';
import openSocialModal from '@/widgets/SocialFeed/openSocialModal';
import Icon from '@/components/Icon';
import state from '@/state';
import Link from '@/components/Link';
import Avatar from '@/components/Avatar';

import { defineAsyncComponent } from 'vue';

const NotificationList = defineAsyncComponent(() => {
  return import(/* webpackChunkName: "stage-2" */'./List');
});

import CompactProfileCard from '@/components/CompactProfileCard';
import DropdownContent from '@/components/DropdownContent';

export default {
  name: 'Notifications/Dropdown',
  components: {
    Icon,
    NotificationList,
    CompactProfileCard,
    DropdownContent,
    Link,
    Avatar,
  },
  async mounted () {
    notificationFetcher.addEventListener('newNotificationCount', this.onNewNotificationCount);

    this.config.myPagesUrl = state.merchantConfig.notifications.avatar.myPagesUrl;
    this.config.notificationAvatar = state.merchantConfig.notifications.avatar.enabled;
  },
  unmounted () {
    notificationFetcher.removeEventListener('newNotificationCount', this.onNewNotificationCount);
  },
  data () {
    return {
      state,

      cursor: undefined,
      newNotificationCount: notificationFetcher.getNewNotificationCount(),
      isOpen: false,
      events: [],

      config: {
        myPagesUrl: null,
        notificationAvatar: false,
      },

      countInterval: null,
    };
  },
  computed: {
    profile() {
      return this.state.profile;
    },
    useAvatarIcon () {
      const mc = state.merchantConfig;
      if (mc?.notifications?.useIcon) {
        return false;
      }
      if (mc.avatars.enabled === 'disabled') {
        return false;
      }
      return true;
    },
  },
  methods: {
    t: state.t.prefix('notifications'),
    openSocialModal,
    onNewNotificationCount (count) {
      if (this.newNotificationCount !== count) {
        this.newNotificationCount = count;
        const countEl = this.$refs.count;
        if (countEl) {
          countEl.style.animation = 'unset';
          this.$nextTick(()=>{
            countEl.style.animation = null;
          });
        }
      }
    },
    open () {
      this.isOpen = true;
      notificationFetcher.setNewNotificationCount(0);
      this.newNotificationCount = 0;
    },
    close () {
      this.isOpen = false;
    },
    toggle () {
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    },
  },
};
</script>
